// Plain JavaScript (React) — no TypeScript. Logic unchanged.
/* eslint-disable */

import React, { useEffect, useRef, forwardRef, useState } from 'react';
import DOMPurify from 'dompurify';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import dayjs from 'dayjs';

// material
import { styled } from '@mui/material/styles';

import {
  Box,
  Button,
  Typography,
  Container,
  Card,
  Grid,
  Chip,
  Tab,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Slide,
  CardActions,
  CardHeader,
  LinearProgress,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
  IconButton,
  Tooltip
} from '@mui/material';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import CallMadeIcon from '@mui/icons-material/CallMade';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { ReactComponent as AnnouncedIcon } from '../../public/static/dashboard/sound_max.svg';
import {
  crossMarkString,
  crossMarkDeviceIdString,
  showLanguageLabelUsingCode,
  getTransactionAnnouncedOrNot,
  parseValidationErrorMessage,
  getBatteryPerceByVBAT,
  crossMarkStringTransId,
  capitalizeFirstLetter,
  parseValidationErrorMessageWithBlobSupport
} from '../utils/Utilities';
import {
  fToNow,
  isoDateFToNow,
  isoDateFormatInDmyhs,
  getDateINYMD,
  isoDateFormatDmyhs,
  convertUTCtoIST,
  fdatetimeWithDash
} from '../utils/formatTime';
import { subDays } from 'date-fns';

import { fShortenNumber } from '../utils/formatNumber';
// components
import Page from '../components/Page';
import {
  DeviceEventRequestByServer,
  GetDeviceDetails,
  GetDeviceHeartBeat,
  GetDeviceLiveStatus,
  GetDeviceTransactions,
  GetHeartBeatTrend
} from '../network/Device';
import {
  GetAllMerchants,
  GetMerchantVpaById,
  GetMerchantById,
  GetMerchantTransactions,
  GetMerchantTransactionStats,
  ExportMerchantTransactionHistoryReport
} from '../network/Merchants';
import { TestSoundBoxPaymentModal } from '../components/_dashboard/soundbox';
import { APP_CONSTANTS, DEVICE_TYPES } from '../URLConstants';
import { useAuth } from '../components/customContextProviders/AuthContext';
import NoxLanguageChangeModal from '../components/_dashboard/soundbox/NoxLanguageChangeModal';
import DashboardNavbar from '../layouts/dashboard/DashboardNavbar';
import DashboardSidebar from '../layouts/dashboard/DashboardSidebar';
import MCC_LIST from '../../public/static/mcc.json';
import SnackBarAlert from '../components/HelperComponents/SnackBarAlert';
import ScanAndPayModal from '../components/QRcards/ScanAndPayModal';
import ComplaintTicketsModal from '../components/_dashboard/app/ComplaintTicketsModal';
import ExportDataModal from '../components/_dashboard/app/ExportDataModal';
import {
  BatteryTrendGraph,
  DateSelectorModal,
  MapWithMarker,
  RebootTrendGraph
} from '../components/_dashboard/trendGraphs';
import { ReactComponent as RedirectIcon } from '../icons/redirectIcon.svg';
import AddTicketModal from '../ticketManagement/components/AddTicketModal';
import { GetAllTickets } from '../ticketManagement/network/Ticket';
import { buildTicketListQueryParams } from '../ticketManagement/utils/ticketManagementUtils';
import { GetAllOrganinazationUser } from '../network/Organization';

// ----------------------------------------------------------------------

function ticketStatusToStatsKey(status) {
  if (typeof status === 'number') {
    const m = {
      2: 'open',
      3: 'pending',
      4: 'resolved',
      5: 'closed',
      6: 'waitingOnCustomer',
      7: 'waitingOnThirdParty'
    };
    return m[status] || 'open';
  }
  const s = String(status || '')
    .toLowerCase()
    .trim();
  if (s.includes('third')) return 'waitingOnThirdParty';
  if (s.includes('customer')) return 'waitingOnCustomer';
  if (s === 'open') return 'open';
  if (s === 'pending') return 'pending';
  if (s === 'resolved') return 'resolved';
  if (s === 'closed') return 'closed';
  return 'open';
}

function mapMerchantTicketForUi(t) {
  return {
    id: t.id,
    status: t.status,
    custom_fields: { cf_complaint_type: t.ticketType },
    description_text: t.description,
    created_at: t.createdAt,
    updated_at: t.updatedAt,
    freshdeskTicketId: t.freshdeskTicketId
  };
}

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */

let currentPage = 1;

export default function SoundBoxDeviceDetails() {
  const location = useLocation();
  const { merchantId, organizationId } = useParams();
  const [amount, setAmount] = useState('');

  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [openTickets, setOpenTickets] = useState(false);
  const { sessionUserData, userLoginOrg, languageList, fetchLanguages } = useAuth();

  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(getDateINYMD(new Date()));
  const [endDate, setEndDate] = useState(getDateINYMD(new Date()));
  const [isUpdatedDeviceModal, setIsUpdatedDeviceModal] = useState(false);
  const [deviceDetails, setDeviceDetails] = useState({
    data: {},
    heartBeat: {},
    loading: false,
    lotDetails: {},
    fotaUpdatedAt: ''
  });
  const [checkerMakerDetails, setCheckerMakerDetails] = useState([]);
  const [checkerMakerUserDetails, setCheckerMakerUserDetails] = useState({});
  const [simDetails, setSimDetails] = useState({
    msisdin: '',
    dataUsage: {},
    data: {},
    location: {}
  });
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [deviceTransactionsList, setDeviceTransactionsList] = useState({
    data: [],
    metas: {},
    loading: false
  });
  const [deviceTransactionsListMetas, setDeviceTransactionsListMetas] = useState([]);
  const [isNoxDeviceLangugeChangeModalOpen, setIsNoxDeviceLangugeChangeModalOpen] = useState(false);
  const [isRebootRequestDialogOpen, setIsRebootRequestDialogOpen] = useState(false);
  const [isTestSoundBoxModalOpen, setIsTestSoundBoxModalOpen] = useState(false);
  const [merchantTicketStats, setMerchantTicketStats] = useState({
    stats: {},
    loading: false
  });

  const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
  const [snackBarMetas, setSnackBarMetas] = useState({
    title: '',
    message: '',
    severity: 'info',
    handleClose: null
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const todayTableRef = useRef(null);
  const last3DaysTableRef = useRef(null);
  const allTimeTableRef = useRef(null);
  const [selectedStatus, setSelectedStatus] = useState(null); // e.g., 'open', 'resolved', etc.
  const [isDateSelectorModalOpen, setIsDateSelectorModalOpen] = useState(false);
  const [heartBeatTrendData, setHeartBeatTrendData] = useState([]);
  const [buttonUsageTrendData, setButtonUsageTrendData] = useState([]);
  const [rebootTrendData, setRebootTrendData] = useState([]);
  const [heartBeatTrendGranularity, setHeartBeatTrendGranularity] = useState('minute');
  const [deviceStatus, setDeviceStatus] = useState('---');
  const [openCreateTicketModal, setOpenCreateTicketModal] = useState(false);
  const [merchantBranchDetails, setMerchantBranchDetails] = useState({});
  let statusColor = 'black';

  useEffect(() => {
    getDetailsUsingDandMId();
    fetchLanguages();
    return () => { };
  }, []);

  const [graphTabValue, setGraphTabValue] = useState('BATTERY');
  const [transactionsTabValue, setTransactionsTabValue] = useState('1');
  const [openExportTransactionModal, setOpenExportTransactionModal] = useState(false);
  const [transactionExportLoading, setTransactionExportLoading] = useState(false);

  const getDefaultLimitValue = (tabType) => {
    if (tabType === '1') return 10;
    if (tabType === '2') return 15;
    if (tabType === '3') return 20;
  };

  const handleGraphTabValueChange = (_event, newValue) => {
    setGraphTabValue(newValue);
  };

  const handleTransactionsTabValueChange = (_event, newValue) => {
    setTransactionsTabValue(newValue);
    currentPage = 1;

    switch (newValue) {
      case '1': {
        setStartDate(getDateINYMD(new Date()));
        setEndDate(getDateINYMD(new Date()));
        fetchMerchantTransactions(
          {
            merchantId,
            ...(amount && { amount })
          },
          currentPage,
          getDefaultLimitValue(newValue),
          getDateINYMD(new Date()),
          getDateINYMD(new Date())
        );
        fetchTotalAmountOfMerchantByDate(
          deviceDetails?.data?.vpa,
          getDateINYMD(new Date()),
          getDateINYMD(new Date())
        );
        break;
      }
      case '2': {
        setStartDate(getDateINYMD(subDays(new Date(), 3)));
        setEndDate(getDateINYMD(new Date()));
        fetchMerchantTransactions(
          {
            merchantId,
            ...(amount && { amount })
          },
          currentPage,
          getDefaultLimitValue(newValue),
          getDateINYMD(subDays(new Date(), 3)),
          getDateINYMD(new Date())
        );
        fetchTotalAmountOfMerchantByDate(
          deviceDetails?.data?.vpa,
          getDateINYMD(subDays(new Date(), 3)),
          getDateINYMD(new Date())
        );
        break;
      }
      case '3': {
        setStartDate(getDateINYMD(subDays(new Date(), 365)));
        setEndDate(getDateINYMD(new Date()));
        fetchMerchantTransactions(
          {
            merchantId,
            ...(amount && { amount })
          },
          currentPage,
          getDefaultLimitValue(newValue),
          getDateINYMD(subDays(new Date(), 365)),
          getDateINYMD(new Date())
        );
        fetchTotalAmountOfMerchantByDate(
          deviceDetails?.data?.vpa,
          getDateINYMD(subDays(new Date(), 365)),
          getDateINYMD(new Date())
        );
        break;
      }
      default: {
        alert('Something went wrong !');
      }
    }
  };

  const handleRebootConfirmDialogClose = (_event) => {
    setIsRebootRequestDialogOpen(false);
  };

  function onUpdateDeviceModalAction(d) {
    alert(d);
  }

  function getDetailsUsingDandMId() {
    getAudioCubeMerchantDetails(merchantId);

    fetchMerchantTransactions(
      {
        merchantId,
        ...(amount && { amount })
      },
      1,
      getDefaultLimitValue('1'),
      getDateINYMD(new Date()),
      getDateINYMD(new Date())
    );
  }

  // There is no separate approval-history endpoint: the merchant VPA record carries who
  // actioned it (`actionedBy`), when (`actionedAt`) and the outcome (`approvalStatus`).
  // Mapped into the approved/rejected shape the section below renders.
  function fetchCheckerMakerDetails(merchant) {
    GetMerchantVpaById(merchant)
      .then((res) => {
        const vpa = res?.data;
        const approvalStatus = vpa?.approvalStatus?.toUpperCase();
        const isApproved = approvalStatus === 'APPROVED';
        const isRejected = approvalStatus === 'REJECTED';
        if (!vpa?.actionedBy || (!isApproved && !isRejected)) {
          setCheckerMakerDetails([]);
          return;
        }
        setCheckerMakerDetails([
          {
            ...(isApproved && { approvedBy: vpa.actionedBy, approvedAt: vpa.actionedAt }),
            ...(isRejected && {
              rejectedBy: vpa.actionedBy,
              rejectedAt: vpa.actionedAt,
              rejectionReason: vpa.remarks
            })
          }
        ]);
        fetchUserDetailsById(vpa.actionedBy);
      })
      .catch((err) => {
        console.log(err, 'error');
      });
  }

  function fetchMerchantBranchDetails(merchantId) {
    GetAllMerchants(1, 10, { id: merchantId })
      .then((res) => {
        setMerchantBranchDetails(res?.data?.data?.[0]);
      })
      .catch((err) => {
        console.log(err, 'error');
      });
  }

  function fetchUserDetailsById(userId) {
    GetAllOrganinazationUser(1, 10, { id: userId })
      .then((res) => {
        console.log(res, 'res');
        setCheckerMakerUserDetails(res?.data?.data?.[0]);
      })
      .catch((err) => {
        console.log(err, 'error');
      });
  }

  function fetchDeviceHeartBeat(deviceId) {
    GetDeviceHeartBeat(deviceId)
      .then((res) => {
        setDeviceDetails((prevDetails) => ({
          ...prevDetails,
          heartBeat: res?.data?.[0] || res?.data?.data?.[0]
        }));
      })
      .catch((_err) => { });
  }

  function fetchDeviceDetails(id) {
    const where = {
      id
    };
    GetDeviceDetails(where)
      .then((res) => {
        setDeviceDetails((prev) => ({
          ...prev,
          lotDetails: res?.data?.data?.[0]
        }));
      })
      .catch((err) => {
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: `Failed to fetch lot details. ${parseValidationErrorMessage(err)}`,
          severity: 'error'
        }));
        setIsSnackBarAlertOpen(true);
      });
  }

  function fetchHeartBeatTrend(deviceId, fromDate, toDate, interval) {
    setHeartBeatTrendGranularity(interval || 'minute');
    GetHeartBeatTrend(deviceId, fromDate, toDate, interval)
      .then((res) => {
        setHeartBeatTrendData(res?.data?.data || []);
        setRebootTrendData(res?.data?.events || []);
      })
      .catch((_err) => {
        setHeartBeatTrendData([]);
      });
  }

  function fetchDeviceStatus(deviceId) {
    GetDeviceLiveStatus(deviceId)
      .then((res) => {
        setDeviceStatus(res?.data?.isOnline ? 'Online' : 'Offline');
      })
      .catch((err) => {
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: `Failed to fetch Device Status. ${parseValidationErrorMessage(err)}`,
          severity: 'error'
        }));
        setIsSnackBarAlertOpen(true);
      });
  }

  const handleDateSelectorApply = ({ startDate, endDate, interval }) => {
    if (deviceDetails?.data?.deviceId) {
      fetchHeartBeatTrend(deviceDetails?.data?.deviceId, startDate, endDate, interval);
    }
  };

  function getAudioCubeMerchantDetails(merchantId) {
    setDeviceDetails((prev) => ({
      ...prev,
      loading: true
    }));
    GetMerchantById(merchantId)
      .then((res) => {
        setDeviceDetails((prevDetails) => ({
          ...prevDetails,
          data: res?.data,
          loading: false
        }));
        fetchTotalAmountOfMerchantByDate(
          res?.data?.vpa,
          getDateINYMD(new Date()),
          getDateINYMD(new Date())
        );

        fetchTicketsForMerchant(res?.data?.id);
        fetchCheckerMakerDetails(res?.data?.id);
        fetchMerchantBranchDetails(res?.data?.id);

        setSelectedLanguage(res?.data?.language?.toLowerCase());

        if (res?.data?.deviceId) {
          fetchDeviceHeartBeat(res?.data?.deviceId);
          fetchHeartBeatTrend(
            res?.data?.deviceId,
            getDateINYMD(subDays(new Date(), 7)),
            getDateINYMD(new Date()),
            'minute'
          );

          fetchDeviceStatus(res?.data?.deviceId);
          fetchDeviceDetails(res?.data?.deviceId);
        }
      })
      .catch((_error) => {
        setDeviceDetails((prev) => ({
          ...prev,
          loading: false
        }));
      });
  }

  function fetchMerchantTransactions(serachBy, pageNo, limit, startDate, endDate, type) {
    setDeviceTransactionsList((prevState) => ({
      ...prevState,
      loading: true
    }));

    GetMerchantTransactions(serachBy, pageNo, limit, startDate, endDate)
      .then((res) => {
        if (type === 'ADD')
          setDeviceTransactionsList((prevState) => ({
            ...prevState,
            data: [...(prevState?.data ?? []), ...(res?.data?.data ?? [])],
            metas: res?.data,
            loading: false
          }));
        else
          setDeviceTransactionsList({
            ...deviceTransactionsList,
            data: res?.data?.data,
            metas: res?.data,
            loading: false
          });
      })
      .catch((_err) => {
        setDeviceTransactionsList((prevState) => ({
          ...prevState,
          loading: true
        }));
      });
  }

  function fetchTotalAmountOfMerchantByDate(vpa, fromDate, toDate) {
    GetMerchantTransactionStats(fromDate, toDate, vpa)
      .then((res) => {
        setDeviceTransactionsListMetas(res?.data?.result?.data);
      })
      .catch((_error) => { });
  }

  function callDeviceRebootRequets(deviceId) {
    if (deviceId === null || deviceId === undefined) {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: 'Device is not assigned yet',
        severity: 'warning'
      }));
      setIsSnackBarAlertOpen(true);
      return;
    }
    setIsRebootRequestDialogOpen(true);
  }

  function rebootDevice(deviceId) {
    DeviceEventRequestByServer(deviceId, deviceId, 'DEVICE_REBOOT', [], new Date().getTime())
      .then((_res) => {
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: 'Device rebooted successfully',
          severity: 'success'
        }));
        setIsSnackBarAlertOpen(true);
      })
      .catch((err) => {
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: parseValidationErrorMessage(err),
          severity: 'error'
        }));
        setIsSnackBarAlertOpen(true);
      });
  }
  function callDeviceLanguageChangeRequet() {
    if (deviceDetails?.data?.deviceId === null || deviceDetails?.data?.deviceId === undefined) {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: 'Device is not assigned yet',
        severity: 'warning'
      }));
      setIsSnackBarAlertOpen(true);
      return;
    }

    setIsNoxDeviceLangugeChangeModalOpen(true);
  }

  function callTestPaymentModal(deviceId) {
    if (deviceId === null || deviceId === undefined) {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: 'Device is not assigned yet',
        severity: 'warning'
      }));
      setIsSnackBarAlertOpen(true);
      return;
    }

    setIsTestSoundBoxModalOpen(true);
  }

  function onDeviceLanguageChangeModalAction(msg) {
    setSnackBarMetas((prevState) => ({
      ...prevState,
      title: msg,
      severity: 'info'
    }));
    setIsSnackBarAlertOpen(true);
  }

  const runTransactionExportDownload = async (vpa, formattedStart, formattedEnd) => {
    setTransactionExportLoading(true);
    try {
      const res = await ExportMerchantTransactionHistoryReport(vpa, formattedStart, formattedEnd);
      const blob = new Blob([res?.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'MerchantTransactionHistory.csv';
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      const errorMessage = await parseValidationErrorMessageWithBlobSupport(error);
      setSnackBarMetas((prev) => ({
        ...prev,
        title: errorMessage,
        severity: 'error'
      }));
      setIsSnackBarAlertOpen(true);
    } finally {
      setTransactionExportLoading(false);
    }
  };

  const handleDownloadTransactionsClick = async () => {
    const vpa = deviceDetails?.data?.vpa;
    if (!vpa) {
      setSnackBarMetas((prev) => ({
        ...prev,
        title: 'VPA is not available for this device.',
        severity: 'error'
      }));
      setIsSnackBarAlertOpen(true);
      return;
    }
    if (transactionsTabValue === '3') {
      setOpenExportTransactionModal(true);
      return;
    }
    let exportStart;
    let exportEnd;
    if (transactionsTabValue === '1') {
      const dateToday = getDateINYMD(new Date());
      exportStart = dateToday;
      exportEnd = dateToday;
    } else if (transactionsTabValue === '2') {
      exportStart = getDateINYMD(subDays(new Date(), 3));
      exportEnd = getDateINYMD(new Date());
    } else {
      return;
    }
    await runTransactionExportDownload(vpa, exportStart, exportEnd);
  };

  const handleExportTransactionModalAction = async ({ startDate, endDate }) => {
    if (!startDate || !endDate) {
      setSnackBarMetas((prev) => ({
        ...prev,
        title: 'Please select start and end dates.',
        severity: 'warning'
      }));
      setIsSnackBarAlertOpen(true);
      return;
    }
    const vpa = deviceDetails?.data?.vpa;
    if (!vpa) return;
    const formattedStart = dayjs(startDate).format('YYYY-MM-DD');
    const formattedEnd = dayjs(endDate).format('YYYY-MM-DD');
    await runTransactionExportDownload(vpa, formattedStart, formattedEnd);
  };

  function onTestSoundBoxPaymentModalAction(d) {
    setSnackBarMetas((prevState) => ({
      ...prevState,
      title: d,
      severity: 'info'
    }));
    setIsSnackBarAlertOpen(true);
  }

  const handleScroll = (ref) => {
    const card = ref.current;
    if (card) {
      const scrollPercentage = (card.scrollTop / (card.scrollHeight - card.clientHeight)) * 100;
      if (scrollPercentage > 90 && deviceTransactionsList?.metas?.hasNextPage) {
        if (!deviceTransactionsList?.loading) {
          currentPage += 1;

          let startDate = '';
          let endDate = '';

          if (transactionsTabValue === '1') {
            startDate = getDateINYMD(new Date());
            endDate = getDateINYMD(new Date());
          } else if (transactionsTabValue === '2') {
            startDate = getDateINYMD(subDays(new Date(), 3));
            endDate = getDateINYMD(new Date());
          } else if (transactionsTabValue === '3') {
            startDate = getDateINYMD(subDays(new Date(), 365));
            endDate = getDateINYMD(new Date());
          }

          fetchMerchantTransactions(
            {
              merchantId,
              ...(amount && { amount })
            },
            currentPage,
            10,
            startDate,
            endDate,
            'ADD'
          );
          fetchTotalAmountOfMerchantByDate(deviceDetails?.data?.vpa, startDate, endDate);
        }
      }
    }
  };

  if (deviceStatus === 'Online') {
    statusColor = '#0DA626';
  } else if (deviceStatus === 'Offline') {
    statusColor = 'red';
  }

  function fetchTicketsForMerchant(merchantId) {
    setMerchantTicketStats((prev) => ({
      ...prev,
      loading: true
    }));

    const ticketsRequest = !merchantId
      ? Promise.resolve({ data: { data: { tickets: [], total: 0 } } })
      : GetAllTickets(1, 100, { merchantId });

    ticketsRequest
      .then((res) => {
        const ticketsPayload = res?.data?.data;
        const ticketsArray = ticketsPayload?.tickets ?? ticketsPayload ?? [];
        const total = res?.data?.total ?? ticketsPayload?.total ?? ticketsArray?.length ?? 0;

        const tickets = ticketsArray.map(mapMerchantTicketForUi);

        const counts = {
          open: 0,
          pending: 0,
          resolved: 0,
          closed: 0,
          waitingOnCustomer: 0,
          waitingOnThirdParty: 0
        };

        tickets.forEach((ticket) => {
          const statusKey = ticketStatusToStatsKey(ticket.status);
          if (Object.prototype.hasOwnProperty.call(counts, statusKey)) {
            counts[statusKey] += 1;
          }
        });

        setMerchantTicketStats((prev) => ({
          ...prev,
          stats: {
            counts,
            tickets,
            total
          },
          loading: false
        }));
      })
      .catch((err) => {
        console.error('Error fetching merchant tickets:', err);
        setMerchantTicketStats((prev) => ({
          ...prev,
          loading: false
        }));
      });
  }
  const handleStatusClick = (statusKey) => {
    const tickets = merchantTicketStats?.stats?.tickets;

    let hasTickets = false;

    if (statusKey === 'total') {
      hasTickets = tickets && tickets.length > 0;
    } else {
      hasTickets = tickets?.some((ticket) => ticketStatusToStatsKey(ticket.status) === statusKey);
    }

    if (hasTickets) {
      setSelectedStatus(statusKey);
      setModalOpen(true);
    } else {
      setSnackbarMessage(`No ${statusKey} tickets found`);
      setSnackbarOpen(true);
    }
  };

  const isCBIorBOMEnvironment =
    process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER ||
    process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID === APP_CONSTANTS?.BOM_CLIENT_IDENTIFIER;

  // userLoginOrg is resolved (per env) from UAT_ORG_IDS/PROD_ORG_IDS in AuthContext,
  // so gating against the env-appropriate map's keys covers both env and login in one check.
  const isQRCardEnabledOrg = Object.keys(
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? APP_CONSTANTS?.PROD_ORG_IDS || {}
      : APP_CONSTANTS?.UAT_ORG_IDS || {}
  ).includes(userLoginOrg);

  const MerchantDetailsCard = (
    <Card
      data-testid="merchant-details-card"
      sx={{
        p: 2,
        backgroundColor: '#FFF',
        boxShadow: '0px 0px 10px 1px #EAEAFF',
        borderRadius: '10px',
        // flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
        // height: '100%'
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          mb: 1.5,
          color: '#171D40',
          fontFamily: 'Montserrat'
        }}
      >
        Merchant Details
      </Typography>
      <Grid container spacing={1}>
        {isCBIorBOMEnvironment && (
          <>
            <Grid size={{ xs: 6, sm: 4, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">VPA</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Typography className="font14 fontWeight700">
                {deviceDetails?.data?.vpa || '---'}
              </Typography>
            </Grid>
          </>
        )}
        <Grid size={{ xs: 4 }}>
          <Typography className="font14 textGray fontWeight700">Merchant ID</Typography>
        </Grid>
        <Grid size={{ xs: 8 }}>
          <Typography className="font14 fontWeight700">
            {crossMarkString(deviceDetails?.data?.mid) || '---'}
          </Typography>
        </Grid>

        {userLoginOrg === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER && (
          <>
            <Grid size={{ xs: 6, sm: 4, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Phone</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Typography className="font14 fontWeight700">
                {deviceDetails?.data?.phone || '---'}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">MCC</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {MCC_LIST.find(
                    (item) => String(item.MCCCode) === String(deviceDetails?.data?.details?.mcc)
                  )?.MCCName || 'Unknown MCC'}{' '}
                  ({deviceDetails?.data?.details?.mcc})
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Account No</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.data?.details?.uniqueRef || '---'}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Account Type</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.data?.details?.accountType || '---'}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Boarding Type</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.data?.details?.onBoardingType || '---'}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">GST No</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.data?.details?.gstIn || '---'}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Verified</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.data?.details?.isVerified === 'N'
                    ? 'Not Verified'
                    : 'Verified' || '---'}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Merchant Genre</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.data?.details?.merchantGenre || '---'}
                </Typography>
              </Stack>
            </Grid>

            {checkerMakerDetails?.[0]?.approvedBy && (
              <>
                <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
                  <Typography className="font14 textGray fontWeight700">Approved By</Typography>
                </Grid>
                <Grid size={{ xs: 6, sm: 8, md: 8 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                  >
                    <Typography className="font14 fontWeight700">
                      {checkerMakerDetails?.length > 0 ? checkerMakerUserDetails?.name : '---'}
                    </Typography>
                  </Stack>
                </Grid>

                <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
                  <Typography className="font14 textGray fontWeight700">Approved At</Typography>
                </Grid>
                <Grid size={{ xs: 6, sm: 8, md: 8 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                  >
                    <Typography className="font14 fontWeight700">
                      {checkerMakerDetails?.length > 0
                        ? fdatetimeWithDash(checkerMakerDetails?.[0]?.approvedAt)
                        : '---'}
                    </Typography>
                  </Stack>
                </Grid>
              </>
            )}

            {checkerMakerDetails?.[0]?.rejectedBy && (
              <>
                <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
                  <Typography className="font14 textGray fontWeight700">Rejected By</Typography>
                </Grid>
                <Grid size={{ xs: 6, sm: 8, md: 8 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                  >
                    <Typography className="font14 fontWeight700">
                      {checkerMakerDetails?.length > 0 ? checkerMakerUserDetails?.name : '---'}
                    </Typography>
                  </Stack>
                </Grid>

                <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
                  <Typography className="font14 textGray fontWeight700">Rejected At</Typography>
                </Grid>
                <Grid size={{ xs: 6, sm: 8, md: 8 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                  >
                    <Typography className="font14 fontWeight700">
                      {checkerMakerDetails?.length > 0
                        ? fdatetimeWithDash(checkerMakerDetails?.[0]?.rejectedAt)
                        : '---'}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
                  <Typography className="font14 textGray fontWeight700">
                    Rejection Reason
                  </Typography>
                </Grid>
                <Grid size={{ xs: 6, sm: 8, md: 8 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                  >
                    <Typography className="font14 fontWeight700">
                      {checkerMakerDetails?.length > 0
                        ? checkerMakerDetails?.[0]?.rejectionReason
                        : '---'}
                    </Typography>
                  </Stack>
                </Grid>
              </>
            )}

            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Address</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {merchantBranchDetails?.deliveryAddress ? merchantBranchDetails?.deliveryAddress : '---'}
                </Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Pincode</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.data?.deliveryPincode ? deviceDetails?.data?.deliveryPincode : '---'}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">City</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700" sx={{ textTransform: 'capitalize' }}>
                  {deviceDetails?.data?.deliveryCity ? deviceDetails?.data?.deliveryCity : '---'}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 6, sm: 4, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Terminal ID</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 8, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.data?.terminalId ? deviceDetails?.data?.terminalId : '---'}
                </Typography>
              </Stack>
            </Grid>
          </>
        )}

        <Grid size={{ xs: 6, sm: 4, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">State </Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 8, md: 8 }}>
          <Typography className="font14 fontWeight700" sx={{ textTransform: 'capitalize' }}>
            {deviceDetails?.data?.deliveryState === 'Mumbai' ? 'Maharastra' : deviceDetails?.data?.deliveryState}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );

  const MerchantBranchDetailsCard = (
    <Card
      data-testid="merchant-branch-details-card"
      sx={{
        p: 2,
        backgroundColor: '#FFF',
        boxShadow: '0px 0px 10px 1px #EAEAFF',
        borderRadius: '10px',
        // flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
        // height: '100%'
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          mb: 1.5,
          color: '#171D40',
          fontFamily: 'Montserrat'
        }}
      >
        Branch Details
      </Typography>
      <Grid container spacing={1}>
        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Branch ID</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Typography className="font14 fontWeight700">
              {merchantBranchDetails?.branchId || '---'}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Branch Name</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Typography className="font14 fontWeight700" sx={{ textTransform: 'capitalize' }}>
              {merchantBranchDetails?.branchData?.name || '---'}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Head Office</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Typography className="font14 fontWeight700" sx={{ textTransform: 'capitalize' }}>
              {merchantBranchDetails?.branchData?.headOfficeName || '---'}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Regional Office</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Typography className="font14 fontWeight700" sx={{ textTransform: 'capitalize' }}>
              {merchantBranchDetails?.branchData?.regionalOfficeName || '---'}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Zone Office</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Typography className="font14 fontWeight700" sx={{ textTransform: 'capitalize' }}>
              {merchantBranchDetails?.branchData?.zoneOfficeName || '---'}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );

  const QRStringCard = (
    <Card
      data-testid="qr-string-card"
      sx={{
        p: 2,
        backgroundColor: '#FFF',
        boxShadow: '0px 0px 10px 1px #EAEAFF',
        borderRadius: '10px',
        // flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
        // height: '100%'
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          mb: 1.5,
          color: '#171D40',
          fontFamily: 'Montserrat'
        }}
      >
        QR String
      </Typography>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
            mb={2}
          >
            <Typography
              className="font14 textGray fontWeight700"
              sx={{
                wordBreak: 'break-all',
                whiteSpace: 'normal'
              }}
            >
              {deviceDetails?.data?.qrString || '---'}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );

  const DeviceDetailsCard = (
    <Card
      data-testid="device-details-card"
      sx={{
        p: 2,
        backgroundColor: '#FFF',
        boxShadow: '0px 0px 10px 1px #EAEAFF',
        borderRadius: '10px',
        // flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
        // height: '100%'
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          mb: 1.5,
          color: '#171D40',
          fontFamily: 'Montserrat'
        }}
      >
        Device Details
      </Typography>
      <Grid container spacing={1}>
        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Device</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Typography className="font14 fontWeight700">
              {deviceDetails?.data?.activated ? 'Active' : 'Inactive'}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Device ID</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Typography className="font14 fontWeight700">
            {(sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN
              ? deviceDetails?.data?.deviceId
              : crossMarkDeviceIdString(deviceDetails?.data?.deviceId)) || '---'}
          </Typography>
        </Grid>

        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Device IMEI</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Typography className="font14 fontWeight700">
            {(sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN
              ? deviceDetails?.lotDetails?.imei
              : crossMarkDeviceIdString(deviceDetails?.lotDetails?.imei)) || '---'}
          </Typography>
        </Grid>

        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Last Heartbeat</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Typography className="font14 fontWeight700">
            {isoDateFormatDmyhs(deviceDetails?.heartBeat?.lastHeartbeat?.updatedAt) || '---'}
          </Typography>
        </Grid>

        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Requested Date</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Typography className="font14 fontWeight700">
            {convertUTCtoIST(deviceDetails?.data?.createdAt) || '---'}
          </Typography>
        </Grid>

        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">FW Version</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Typography className="font14 fontWeight700">
            {crossMarkString(deviceDetails?.heartBeat?.lastHeartbeat?.FWV) || '---'}
          </Typography>
        </Grid>

        {/* <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">Last Updated</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Typography className="font14 fontWeight700">
            {isoDateFormatInDmyhs(deviceDetails?.data?.updatedAt) || '---'}
          </Typography>
        </Grid> */}

        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700">
            {process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID ===
              APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER
              ? 'Soundbox Type'
              : 'Payment Interface Type'}
          </Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Typography className="font14 fontWeight700">
              {DEVICE_TYPES.find(
                (item) => item.value === deviceDetails?.data?.paymentInterfaceType?.[0]
              )?.label || '---'}
            </Typography>
          </Stack>
        </Grid>

        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
          <Typography className="font14 textGray fontWeight700"> Battery </Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Typography className="font14 fontWeight700" sx={{ textTransform: 'capitalize' }}>
              {`${getBatteryPerceByVBAT(deviceDetails?.heartBeat?.lastHeartbeat?.VBAT)}%` || '---'}
            </Typography>
          </Stack>
        </Grid>

        {userLoginOrg === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER && (
          <>
            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Sim Number</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.lotDetails?.settings?.simNumber || '---'}
                </Typography>
              </Stack>
            </Grid>
          </>
        )}

        {userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER && (
          <>
            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Volume</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.heartBeat?.lastHeartbeat?.VOLUME || '---'}
                </Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Sim Operator</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700" sx={{ textTransform: 'capitalize' }}>
                  {deviceDetails?.heartBeat?.lastHeartbeat?.OPERATOR || '---'}
                </Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Flash Available</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {`${deviceDetails?.heartBeat?.lastHeartbeat?.AVAIL_FLASH}%` || '---'}
                </Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Lot Number </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {`${deviceDetails?.lotDetails?.lotNumber}` || '---'}
                </Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Vendor </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {`${deviceDetails?.lotDetails?.vendorName}` || '---'}
                </Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Sim Number</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {simDetails?.dataUsage?.simNumber || '---'}
                </Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">Last FOTA Update</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.fotaUpdatedAt?.payload?.cmd || '---'}
                </Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 6, sm: 6, md: 4 }}>
              <Typography className="font14 textGray fontWeight700">FOTA updated at</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography className="font14 fontWeight700">
                  {isoDateFormatInDmyhs(deviceDetails?.fotaUpdatedAt?.updatedAt) || '---'}
                </Typography>
              </Stack>
            </Grid>
          </>
        )}

        {deviceDetails?.data?.paymentInterfaceType?.[0] !== 'dynamic_qr_soundbox' && (
          <>
            <Grid size={{ xs: 6, sm: 6, md: 4 }} mt={0.5}>
              <Typography className="font14 textGray fontWeight700">Language</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 8 }}>
              <Stack
                direction="row"
                // justifyContent="space-between"
                alignItems="center"
                spacing={1}
              >
                <Typography className="font14 fontWeight700">
                  {deviceDetails?.heartBeat?.lastHeartbeat?.LNG || '---'}
                </Typography>
                <Typography
                  component="button"
                  type="button"
                  data-testid="change_language_button"
                  onClick={() => callDeviceLanguageChangeRequet()}
                  disabled={
                    process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID ===
                    APP_CONSTANTS?.BOM_CLIENT_IDENTIFIER
                  }
                  sx={{
                    p: 0,
                    ml: 0.5,
                    border: 'none',
                    background: 'none',
                    font: 'inherit',
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: 'pointer',
                    color: '#767676',
                    textDecoration: 'underline',
                    '&:disabled': { opacity: 0.5, cursor: 'not-allowed' }
                  }}
                >
                  Change Language
                </Typography>
              </Stack>
            </Grid>
          </>
        )}
        {/* <Grid size={{ xs: 6, sm: 6, md: 2 }}>
                                <Typography className="font14 textGray fontWeight700">
                                  Status
                                </Typography>
                              </Grid>
                              <Grid size={{ xs: 6, sm: 6, md: 2 }}>
                                <Stack
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  spacing={1}
                                >
                                  <Typography className="font14 fontWeight700" color={statusColor}>
                                    {deviceStatus}
                                  </Typography>
                                </Stack>
                              </Grid> */}
      </Grid>
    </Card>
  );

  const DeliveryDetailsCard = (
    <Card
      data-testid="delivery-details-card"
      sx={{
        p: 2,
        backgroundColor: '#FFF',
        boxShadow: '0px 0px 10px 1px #EAEAFF',
        borderRadius: '10px',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 160,
        height: 'auto'
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          mb: 1.5,
          color: '#171D40',
          fontFamily: 'Montserrat'
        }}
      >
        Delivery Details
      </Typography>
      <Grid container spacing={1}>
        {isCBIorBOMEnvironment && (
          <>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 textGray fontWeight700">AWB No</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 fontWeight700">
                {deviceDetails?.data?.awbNumber || '---'}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 textGray fontWeight700">Dispatch Partner</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 fontWeight700">
                {deviceDetails?.data?.partnerName || '---'}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 textGray fontWeight700">Dispatch Status</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 fontWeight700">
                {capitalizeFirstLetter(deviceDetails?.data?.packageStatus) || '---'}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 textGray fontWeight700">
                Last Package Update Date
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 fontWeight700">
                {isoDateFormatInDmyhs(deviceDetails?.data?.packageUpdateAt) || '---'}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Card>
  );

  const isAirtel = deviceDetails?.heartBeat?.lastHeartbeat?.OPERATOR === 'AIRTEL';

  const airtelUsage = simDetails?.dataUsage?.usageDetails?.data?.totalDataUsage;

  const airtelUnit = simDetails?.dataUsage?.usageDetails?.data?.dataUsageUnits;

  const otherUsage = simDetails?.dataUsage?.usageDetails?.recordSet?.find(
    (item) => item.name === 'DATA'
  )?.value;

  let displayUsage = '---';

  if (isAirtel) {
    if (airtelUsage) {
      displayUsage = `${airtelUsage} ${airtelUnit || ''}`;
    }
  } else if (otherUsage) {
    displayUsage = `${otherUsage} MB`;
  }

  const DataUsageCard = (
    <Card
      sx={{
        p: 2,
        backgroundColor: '#FFF',
        boxShadow: '0px 0px 10px 1px #EAEAFF',
        borderRadius: '10px',
        flexGrow: 1, // 🔥 this makes it take remaining height
        display: 'flex',
        flexDirection: 'column',
        height: 'auto'
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          mb: 1.5,
          color: '#171D40',
          fontFamily: 'Montserrat',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <span>Data Usage</span>

        <IconButton
          sx={{ p: 0.5 }}
        // onClick={() => {
        //   fetchSimDataUsage(simDetails?.msisdin);
        // }}
        >
          <RefreshIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Typography>

      <Grid container spacing={1}>
        {isCBIorBOMEnvironment && (
          <>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 textGray fontWeight700">Total Data</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 fontWeight700">{displayUsage}</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 textGray fontWeight700">Used Data</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 fontWeight700">
                {simDetails?.dataUsage?.usageDetails?.data?.totalDataUsage
                  ? `${simDetails?.dataUsage?.usageDetails?.data?.usedDataUsage} ${simDetails?.dataUsage?.usageDetails?.data?.dataUsageUnits}`
                  : '---'}{' '}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 textGray fontWeight700">Remaining Data</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 fontWeight700">
                {simDetails?.dataUsage?.usageDetails?.data?.totalDataUsage
                  ? `${simDetails?.dataUsage?.usageDetails?.data?.remainingDataUsage} ${simDetails?.dataUsage?.usageDetails?.data?.dataUsageUnits}`
                  : '---'}{' '}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Card>
  );

  const ButtonUsageCard = (
    <Card
      sx={{
        p: 2,
        backgroundColor: '#FFF',
        boxShadow: '0px 0px 10px 1px #EAEAFF',
        borderRadius: '10px',
        flexGrow: 1, // 🔥 this makes it take remaining height
        display: 'flex',
        flexDirection: 'column',
        height: 'auto'
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          mb: 1.5,
          color: '#171D40',
          fontFamily: 'Montserrat',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <span>Button Usage Stats</span>
      </Typography>

      <Grid container spacing={1}>
        {isCBIorBOMEnvironment && (
          <>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 textGray fontWeight700" sx={{ lineHeight: '14px' }}>
                Volume Increase
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }} display="flex" alignItems="center">
              <Typography className="font14 fontWeight700">
                {buttonUsageTrendData?.vol_plus || '---'}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }} display="flex" alignItems="center">
              <Typography className="font14 textGray fontWeight700" sx={{ lineHeight: '14px' }}>
                Volumne Decrease
              </Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6 }}>
              <Typography className="font14 fontWeight700">
                {buttonUsageTrendData?.vol_minus || '---'}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Card>
  );

  return (
    <Page title="Merchant Details">
      <DashboardNavbar
        onOpenSidebar={() => setOpen(true)}
        name={
          <>
            Merchant Details -{' '}
            <span style={{ color: '#79797F', fontWeight: 700 }}>{deviceDetails?.data?.name}</span>
            {deviceDetails?.data?.deviceId && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: -0.5, gap: 0.5 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
                  Device Status:{' '}
                  <span
                    style={{
                      color: statusColor,
                      fontWeight: 700
                    }}
                  >
                    {deviceStatus}
                  </span>
                </Typography>
                <IconButton
                  sx={{ p: 0 }}
                  onClick={() => fetchDeviceStatus(deviceDetails?.data?.deviceId)}
                >
                  <RefreshIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Box>
            )}
          </>
        }
      />

      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <Container maxWidth="false">
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={() => setSnackbarOpen(false)} severity="info" sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            height: {
              xl: 'calc(100vh - 90px)',

              xlm: 'calc(100vh - 90px)',

              lg: 'calc(100vh - 80px)',
              md: 'calc(100vh - 80px)'
            },
            overflow: 'auto',
            flexDirection: 'column'
          }}
        >
          <Stack direction="column">
            <Box
              sx={{
                width: '100%',
                overflowY: 'auto',
                pr: 2,
                height: '100%',
                '&::-webkit-scrollbar': {
                  display: 'none'
                },
                msOverflowStyle: 'none', // IE/Edge
                scrollbarWidth: 'none' // Firefox
              }}
            >
              {deviceDetails?.loading ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                    width: '200vh'
                  }}
                >
                  <CircularProgress size={50} thickness={4} sx={{ color: '#1A1A3F' }} />
                </Box>
              ) : (
                <Grid container spacing={1.5}>
                  <Grid size={{ xs: 12, sm: 12, md: 8.5 }}>
                    <Card
                      sx={{
                        p: 2,
                        minHeight: 120,
                        backgroundColor: '#FFF',
                        boxShadow: '0px 0px 10px 1px #EAEAFF',
                        borderRadius: '10px'
                      }}
                    >
                      {deviceDetails?.loading ? (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '50vh',
                            width: '100%'
                          }}
                        >
                          <CircularProgress size={50} thickness={4} sx={{ color: '#1A1A3F' }} />
                        </Box>
                      ) : (
                        <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
                          {userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER && (
                            <>
                              <Grid
                                size={{ md: 6.4 }}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 1
                                }}
                              >
                                {MerchantDetailsCard}
                                {DeviceDetailsCard}
                              </Grid>
                              <Grid
                                size={{ md: 5.5 }}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 1
                                }}
                              >
                                {DataUsageCard}
                                {ButtonUsageCard}
                                <Card
                                  sx={{
                                    p: 2,
                                    backgroundColor: '#FFF',
                                    boxShadow: '0px 0px 10px 1px #EAEAFF',
                                    borderRadius: '10px',
                                    flexGrow: 1, // 🔥 this makes it take remaining height
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: 'auto'
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: 16,
                                      mb: 1.5,
                                      color: '#171D40',
                                      fontFamily: 'Montserrat'
                                    }}
                                  >
                                    Location
                                  </Typography>
                                  <MapWithMarker
                                    customHeight={200}
                                    latitude={simDetails?.location?.lat}
                                    longitude={simDetails?.location?.lng}
                                  />
                                </Card>
                                {DeliveryDetailsCard}
                              </Grid>

                              {/* <Grid size={{ md: 6.4 }}>{DeviceDetailsCard}</Grid> */}
                            </>
                          )}
                          {userLoginOrg === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER && (
                            <>
                              <Grid
                                size={{ md: 5.5 }}
                                sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                              >
                                {MerchantDetailsCard}
                                {QRStringCard}
                              </Grid>
                              <Grid
                                size={{ md: 6.4 }}
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2
                                }}
                              >
                                {DeviceDetailsCard}
                                {MerchantBranchDetailsCard}
                                {DeliveryDetailsCard}
                              </Grid>
                            </>
                          )}{' '}
                          {userLoginOrg !== APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER &&
                            userLoginOrg !== APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER && (
                              <>
                                <Grid
                                  size={{ md: 5.5 }}
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1
                                  }}
                                >
                                  {MerchantDetailsCard}
                                  {DeliveryDetailsCard}
                                </Grid>

                                <Grid size={{ md: 6.4 }} sx={{ display: 'flex' }}>
                                  {DeviceDetailsCard}
                                </Grid>
                              </>
                            )}
                        </Grid>
                      )}
                    </Card>

                    {deviceDetails?.data?.deviceId &&
                      process.env.REACT_APP_ENVIRONMENT === 'sandbox' && (
                        <Grid size={{ xs: 12, sm: 12, md: 12 }} my={2}>
                          <Card
                            sx={{
                              display: 'flex',
                              minHeight: 120,
                              flexDirection: 'column',
                              flex: 1,
                              backgroundColor: '#FFF',
                              boxShadow: '0px 0px 10px 1px #EAEAFF',
                              borderRadius: '10px'
                            }}
                          >
                            <Box
                              onClick={() => setIsDateSelectorModalOpen(true)}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontWeight: 600,
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  backgroundColor: 'rgba(0,0,0,0.05)'
                                },
                                mt: 2,
                                mr: 2,
                                ml: 'auto'
                              }}
                            >
                              <FilterListIcon sx={{ color: '#7D8A96' }} />
                            </Box>

                            <Box sx={{ display: 'flex', gap: 1.5 }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                  gap: 2,
                                  flex: 1,
                                  minHeight: '100%'
                                }}
                              >
                                <BatteryTrendGraph
                                  trendData={heartBeatTrendData}
                                  granularity={heartBeatTrendGranularity}
                                  height="200px"
                                />
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    fontFamily: 'Montserrat',
                                    textAlign: 'center',
                                    py: 2
                                  }}
                                >
                                  Device HeartBeat
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                  gap: 2,
                                  flex: 1,
                                  minHeight: '100%'
                                }}
                              >
                                <RebootTrendGraph
                                  rebootData={rebootTrendData}
                                  granularity={heartBeatTrendGranularity}
                                  height="200px"
                                />
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    fontFamily: 'Montserrat',
                                    textAlign: 'center',
                                    py: 2
                                  }}
                                >
                                  Reboot Trend
                                </Typography>
                              </Box>
                            </Box>
                          </Card>
                        </Grid>
                      )}
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12, md: 3.5 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'flex-end',
                        gap: 2,
                        mb: 2
                      }}
                    >
                      {process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID ===
                        APP_CONSTANTS?.BOI_CLIENT_IDENTIFIER ? (
                        <Button
                          variant="contained"
                          onClick={() => callTestPaymentModal(deviceDetails?.data?.deviceId)}
                          color="whitebg"
                        >
                          Test Payment
                        </Button>
                      ) : null}
                      {isQRCardEnabledOrg ? (
                        <Button
                          data-testid="download_qr_card_button"
                          onClick={() => setIsQRModalOpen(true)}
                          variant="contained"
                          color="whitebg"
                        >
                          <Box sx={{ flexGrow: 1, textAlign: 'left' }}>QR Card</Box>
                        </Button>
                      ) : null}

                      <Button
                        data-testid="reboot_device_button"
                        variant="contained"
                        color="whitebg"
                        onClick={() => {
                          callDeviceRebootRequets(deviceDetails?.data?.deviceId);
                        }}
                      >
                        Reboot
                      </Button>
                      {isCBIorBOMEnvironment ? (
                        <Button
                          variant="contained"
                          data-testid="complaints_drawer"
                          onClick={() => setOpenTickets(!openTickets)}
                          color="whitebg"
                        >
                          <Box sx={{ flexGrow: 1, textAlign: 'left' }}>Complaints</Box>
                          {!openTickets ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                        </Button>
                      ) : null}
                    </Box>
                    {openTickets && (
                      <Card
                        data-testid="merchant_complaints_panel"
                        sx={{
                          p: 2,
                          minHeight: 120,
                          backgroundColor: '#FFF',
                          boxShadow: '0px 0px 10px 1px #EAEAFF',
                          borderRadius: '20px',
                          mb: 2.5
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Box display="flex" alignItems="center">
                              <Typography className="font14 textGray fontWeight700" mr={1}>
                                Total
                              </Typography>
                              <CallMadeIcon
                                data-testid="total-tickets-icon"
                                className="textGray"
                                sx={{ fontSize: '14px', cursor: 'pointer' }}
                                onClick={() => {
                                  handleStatusClick('total');
                                }}
                              />
                            </Box>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Typography className="font14 fontWeight700">
                              {merchantTicketStats?.stats?.total || '---'}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Box display="flex" alignItems="center">
                              <Typography className="font14 textGray fontWeight700" mr={1}>
                                Resolved
                              </Typography>
                              <CallMadeIcon
                                className="textGray"
                                sx={{ fontSize: '14px', cursor: 'pointer' }}
                                onClick={() => {
                                  handleStatusClick('resolved');
                                }}
                              />
                            </Box>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Typography className="font14 fontWeight700">
                              {merchantTicketStats?.stats?.counts?.resolved || '---'}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Box display="flex" alignItems="center">
                              <Typography className="font14 textGray fontWeight700" mr={1}>
                                Open
                              </Typography>
                              <CallMadeIcon
                                className="textGray"
                                sx={{ fontSize: '14px', cursor: 'pointer' }}
                                onClick={() => {
                                  handleStatusClick('open');
                                }}
                              />
                            </Box>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Typography className="font14 fontWeight700">
                              {merchantTicketStats?.stats?.counts?.open || '---'}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Box display="flex" alignItems="center">
                              <Typography className="font14 textGray fontWeight700" mr={1}>
                                Pending
                              </Typography>
                              <CallMadeIcon
                                className="textGray"
                                sx={{ fontSize: '14px', cursor: 'pointer' }}
                                onClick={() => {
                                  handleStatusClick('pending');
                                }}
                              />
                            </Box>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Typography className="font14 fontWeight700">
                              {merchantTicketStats?.stats?.counts?.pending || '---'}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Box display="flex" alignItems="center">
                              <Typography className="font14 textGray fontWeight700" mr={1}>
                                Closed
                              </Typography>
                              <CallMadeIcon
                                className="textGray"
                                sx={{ fontSize: '14px', cursor: 'pointer' }}
                                onClick={() => {
                                  handleStatusClick('closed');
                                }}
                              />
                            </Box>
                          </Grid>
                          <Grid size={{ xs: 6, sm: 3, md: 3 }}>
                            <Typography className="font14 fontWeight700">
                              {merchantTicketStats?.stats?.counts?.closed || '---'}
                            </Typography>
                          </Grid>
                          {/* {process.env.REACT_APP_ENVIRONMENT === 'sandbox' && ( */}
                          <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                            <Box
                              display="flex"
                              alignItems="center"
                              onClick={() => {
                                setOpenCreateTicketModal(true);
                              }}
                            >
                              <Typography
                                className="font14 textGray fontWeight700"
                                mr={1}
                                sx={{ cursor: 'pointer', textWrap: 'nowrap' }}
                              >
                                Raise Complaint
                              </Typography>
                              <RedirectIcon fontSize={20} />
                            </Box>
                          </Grid>
                          {/* )} */}
                        </Grid>
                      </Card>
                    )}
                    <Card
                      data-testid="transcation_card"
                      // className={classes?.cardWithBorder}
                      sx={{
                        maxHeight: 550,
                        height: openTickets
                          ? 430
                          : { xl: 600, xlm: 600, lg: 520, md: 480, sm: 450 },
                        overflow: 'hidden'
                      }}
                    >
                      {deviceTransactionsListMetas?.loading && <LinearProgress color="success" />}
                      <Box sx={{ mt: 2 }}>
                        <Stack
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                          spacing={2}
                          mt={1}
                          // pl={1}
                          // pr={1}
                          sx={{ minHeight: 80 }}
                        >
                          <Typography
                            sx={{
                              p: 2,
                              fontWeight: 600,
                              mb: 1,
                              fontSize: '18px',
                              lineHeight: '23px',
                              color: '#171D40',
                              fontFamily: 'Montserrat'
                            }}
                          >
                            Transactions
                          </Typography>
                          <TextField
                            size="small"
                            label="Amount"
                            value={amount}
                            onChange={(e) => {
                              setAmount(e.target.value);
                              fetchMerchantTransactions(
                                {
                                  merchantId,
                                  ...(e.target.value && { amount: e.target.value }) // only sends amount if non-empty
                                },
                                currentPage,
                                getDefaultLimitValue(transactionsTabValue),
                                startDate,
                                endDate
                              );
                            }}
                          />

                          <Tooltip title="Download Transaction Report" placement="top">
                            <span>
                              <IconButton
                                variant="contained"
                                disabled={transactionExportLoading}
                                onClick={() => handleDownloadTransactionsClick()}
                                sx={{ mr: 2 }}
                              >
                                <FileDownloadOutlinedIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Stack>

                        <TabContext value={transactionsTabValue}>
                          <TabList
                            sx={{
                              '& .MuiTabs-flexContainer': {
                                justifyContent: 'center'
                              }
                            }}
                            onChange={handleTransactionsTabValueChange}
                            aria-label="lab API tabs example"
                          >
                            <Tab label="Today" value="1" />
                            <Tab label="Last 3 Days" value="2" />
                            <Tab label="All Time" value="3" />
                          </TabList>

                          {/* <TabPanel value="1" sx={{ maxHeight: 300, overflow: 'scroll', }} ref={todayTableRef} onScroll={() => handleScroll(todayTableRef)}>

                    <TableContainer > */}
                          <TabPanel value="1">
                            <TableContainer
                              sx={{
                                maxHeight: openTickets
                                  ? 200
                                  : { xl: 350, xlm: 350, lg: 300, md: 280, sm: 250 },
                                overflow: 'scroll',
                                minHeight: openTickets
                                  ? 200
                                  : { xl: 350, xlm: 350, lg: 300, md: 280, sm: 250 }
                              }}
                              ref={todayTableRef}
                              onScroll={() => handleScroll(todayTableRef)}
                            >
                              <Table aria-label="transactions table" stickyHeader>
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '6vw' }}
                                    >
                                      Trans. ID
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '4vw' }}
                                    >
                                      <AnnouncedIcon />
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '4vw' }}
                                    >
                                      Amount
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '7vw' }}
                                    >
                                      Timestamp
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {deviceTransactionsList?.data?.map((row) => (
                                    <TableRow
                                      className="font12"
                                      key={row?.commandId}
                                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                      <TableCell
                                        className="font12"
                                        component="th"
                                        scope="row"
                                        align="center"
                                      >
                                        {crossMarkStringTransId(row?.commandId)}
                                      </TableCell>

                                      <TableCell align="center">
                                        {row?.latency !== null &&
                                          row?.latency !== undefined &&
                                          Object?.keys(row?.latency)?.length > 0
                                          ? 'Yes'
                                          : 'NO'}
                                      </TableCell>

                                      <TableCell className="font12" align="center">
                                        <Typography
                                          className="font12"
                                          sx={{ textAlign: 'center', alignItems: 'center' }}
                                        >
                                          Rs. {row?.amount}
                                        </Typography>
                                      </TableCell>
                                      <TableCell className="font12" align="center">
                                        {isoDateFormatDmyhs(row?.created_at)}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </TabPanel>
                          <TabPanel value="2">
                            <TableContainer
                              sx={{
                                maxHeight: openTickets
                                  ? 200
                                  : { xl: 350, xlm: 350, lg: 300, md: 280, sm: 250 },
                                overflow: 'scroll',
                                minHeight: openTickets
                                  ? 200
                                  : { xl: 350, xlm: 350, lg: 300, md: 280, sm: 250 }
                              }}
                              ref={last3DaysTableRef}
                              onScroll={() => handleScroll(last3DaysTableRef)}
                            >
                              <Table aria-label="transactions table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '6vw' }}
                                    >
                                      Trans. ID
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '4vw' }}
                                    >
                                      <AnnouncedIcon />
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '4vw' }}
                                    >
                                      Amount
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '7vw' }}
                                    >
                                      Timestamp
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {deviceTransactionsList?.data?.map((row) => (
                                    <TableRow
                                      className="font12"
                                      key={row?.commandId}
                                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                      <TableCell
                                        className="font12"
                                        component="th"
                                        scope="row"
                                        align="center"
                                      >
                                        {crossMarkStringTransId(row?.commandId)}
                                      </TableCell>

                                      <TableCell align="center">
                                        {row?.latency !== null &&
                                          row?.latency !== undefined &&
                                          Object?.keys(row?.latency)?.length > 0
                                          ? 'Yes'
                                          : 'NO'}
                                      </TableCell>

                                      <TableCell className="font12" align="center">
                                        <Typography
                                          className="font12"
                                          sx={{ textAlign: 'center', alignItems: 'center' }}
                                        >
                                          Rs. {row?.amount}
                                        </Typography>
                                      </TableCell>
                                      <TableCell className="font12" align="center">
                                        {isoDateFormatDmyhs(row?.created_at)}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </TabPanel>

                          <TabPanel value="3">
                            <TableContainer
                              sx={{
                                maxHeight: openTickets
                                  ? 200
                                  : { xl: 350, xlm: 350, lg: 300, md: 280, sm: 250 },
                                overflow: 'scroll',
                                minHeight: openTickets
                                  ? 200
                                  : { xl: 350, xlm: 350, lg: 300, md: 280, sm: 250 }
                              }}
                              ref={allTimeTableRef}
                              onScroll={() => handleScroll(allTimeTableRef)}
                            >
                              <Table aria-label="transactions table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '6vw' }}
                                    >
                                      Trans. ID
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '4vw' }}
                                    >
                                      <AnnouncedIcon />
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '4vw' }}
                                    >
                                      Amount
                                    </TableCell>
                                    <TableCell
                                      className="font12 fontWeight800"
                                      align="center"
                                      sx={{ minWidth: '7vw' }}
                                    >
                                      Timestamp
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {deviceTransactionsList?.data?.map((row) => (
                                    <TableRow
                                      className="font12"
                                      key={row?.commandId}
                                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                      <TableCell
                                        className="font12"
                                        component="th"
                                        scope="row"
                                        align="center"
                                      >
                                        {crossMarkStringTransId(row?.commandId)}
                                      </TableCell>

                                      <TableCell align="center">
                                        {row?.latency !== null &&
                                          row?.latency !== undefined &&
                                          Object?.keys(row?.latency)?.length > 0
                                          ? 'Yes'
                                          : 'NO'}
                                      </TableCell>

                                      <TableCell className="font12" align="center">
                                        <Typography
                                          className="font12"
                                          sx={{ textAlign: 'center', alignItems: 'center' }}
                                        >
                                          Rs. {row?.amount}
                                        </Typography>
                                      </TableCell>
                                      <TableCell className="font12" align="center">
                                        {isoDateFormatDmyhs(row?.created_at)}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </TabPanel>
                        </TabContext>
                      </Box>

                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          justifyContent: 'center',
                          backgroundColor: 'rgba(195, 10, 10, .1)',
                          width: '100%'
                        }}
                      >
                        <Typography
                          sx={{
                            textAlign: 'center',
                            p: 1,
                            fontSize: 16,
                            fontWeight: 600,
                            fontFamily: 'Montserrat'
                          }}
                        >
                          Total Amount : Rs. {fShortenNumber(deviceTransactionsListMetas?.totalSum)}
                        </Typography>
                      </Box>
                    </Card>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Stack>
        </Box>
        <SnackBarAlert
          open={isSnackBarAlertOpen}
          title={snackBarMetas?.title}
          message={snackBarMetas?.message}
          severity={snackBarMetas?.severity}
          handleClose={() => setIsSnackBarAlertOpen(false)}
        />
        <ExportDataModal
          openDateRangeModal={openExportTransactionModal}
          handleClose={() => setOpenExportTransactionModal(false)}
          actionData={null}
          onAction={handleExportTransactionModalAction}
        />
        <NoxLanguageChangeModal
          languageData={languageList}
          opneAssignedModal={isNoxDeviceLangugeChangeModalOpen}
          handleClose={() => setIsNoxDeviceLangugeChangeModalOpen(false)}
          merchantData={deviceDetails?.data}
          onAction={(d) => onDeviceLanguageChangeModalAction(d)}
        />
        <TestSoundBoxPaymentModal
          selectedMerchant={deviceDetails?.data}
          opneAssignedModal={isTestSoundBoxModalOpen}
          handleClose={() => setIsTestSoundBoxModalOpen(false)}
          onAction={(d) => onTestSoundBoxPaymentModalAction(d)}
        />
        <ComplaintTicketsModal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          merchantTicketStats={merchantTicketStats}
          selectedStatus={selectedStatus}
        />

        <Dialog
          sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
          maxWidth="xs"
          open={isRebootRequestDialogOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleRebootConfirmDialogClose}
        >
          <DialogTitle sx={{ fontFamily: 'Montserrat' }}>Device Reboot</DialogTitle>
          <DialogContent sx={{ fontWeight: 700 }}>Are you sure want to reboot ?</DialogContent>
          <DialogActions>
            <Button variant="outlined" autoFocus onClick={handleRebootConfirmDialogClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                rebootDevice(deviceDetails?.data?.deviceId);
                handleRebootConfirmDialogClose();
              }}
            >
              Yes, Reboot
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
      <ScanAndPayModal
        open={isQRModalOpen}
        onClose={() => setIsQRModalOpen(false)}
        qrString={deviceDetails?.data?.qrString}
        merchantVpa={deviceDetails?.data?.vpa}
        Identifier={userLoginOrg}
        merchantName={deviceDetails?.data?.name}
      />
      <DateSelectorModal
        openDateSelectorModal={isDateSelectorModalOpen}
        handleClose={() => setIsDateSelectorModalOpen(false)}
        onApply={handleDateSelectorApply}
        isInterval
      />

      <AddTicketModal
        open={openCreateTicketModal}
        handleClose={() => setOpenCreateTicketModal(false)}
        merchantDetails={deviceDetails?.data}
        onReload={() => fetchTicketsForMerchant(deviceDetails?.data?.id)}
      />
    </Page>
  );
}
